var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4696 19.7122C25.0552 20.1138 24.8648 20.6946 24.9592 21.2642L26.3816 29.1362C26.5016 29.8034 26.22 30.4786 25.6616 30.8642C25.1144 31.2642 24.3864 31.3122 23.7896 30.9922L16.7032 27.2962C16.4568 27.165 16.1832 27.0946 15.9032 27.0866H15.4696C15.3192 27.109 15.172 27.157 15.0376 27.2306L7.94959 30.9442C7.59919 31.1202 7.20239 31.1826 6.81359 31.1202C5.86639 30.941 5.23439 30.0386 5.38959 29.0866L6.81359 21.2146C6.90799 20.6402 6.71759 20.0562 6.30319 19.6482L0.525591 14.0482C0.042391 13.5794 -0.125609 12.8754 0.095191 12.2402C0.309591 11.6066 0.856791 11.1442 1.51759 11.0402L9.46959 9.88663C10.0744 9.82423 10.6056 9.45623 10.8776 8.91223L14.3816 1.72823C14.4648 1.56823 14.572 1.42103 14.7016 1.29623L14.8456 1.18423C14.9208 1.10103 15.0072 1.03223 15.1032 0.976232L15.2776 0.912232L15.5496 0.800232H16.2232C16.8248 0.862632 17.3544 1.22263 17.6312 1.76023L21.1816 8.91223C21.4376 9.43543 21.9352 9.79863 22.5096 9.88663L30.4616 11.0402C31.1336 11.1362 31.6952 11.6002 31.9176 12.2402C32.1272 12.8818 31.9464 13.5858 31.4536 14.0482L25.4696 19.7122Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.536243873aba2f674f831ff8f52a8d8f.svg";
export { ForwardRef as ReactComponent };